var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "not-found-error h-center-align" }, [
    _c("h1", [_vm._v("Oops!")]),
    _vm._v(" "),
    _c("h3", [
      _vm._v("The " + _vm._s(_vm.resource) + " you're looking for is not here.")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }